'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    zillow: {
        id: 'zillow'
    },
    trulia: {
        id: 'trulia'
    },
    hotpads: {
        id: 'hotpads'
    }
};
//# sourceMappingURL=authZone.js.map